import { motion, AnimateSharedLayout } from 'framer-motion'
import cn from 'clsx'
import styles from './pagedots.css'

type PageDotsProps = {
  pages: Array<any> // eslint-disable-line
  current: number
  className?: string
}

const PageDots = ({ pages, current, className }: PageDotsProps): JSX.Element => (
  <AnimateSharedLayout>
    <ol className={cn(styles.pageDots, className)}>
      {pages.map((_, i) => (
        <li key={String(i)} className={styles.pageDot}>
          {i === current && <motion.div className={styles.pageDotActive} layoutId="pageDot" />}
        </li>
      ))}
    </ol>
  </AnimateSharedLayout>
)

export default PageDots
